import AccordianSlide from '../AccordianSlide'

export default function AboutUsSlide (props) {
  return (
    <AccordianSlide
      title='We are Aragon'
      stageName='Learning about Aragon'
      description='The Aragon Manifesto is the declaration of the ideals held by Aragon. Here are some highlights, however we recommend you read it in full <a class="link" href="https://aragon.org/manifesto" target="_blank">here</a>.'
      accordianData={[
        {
          title: 'Humanity and Innovation',
          body:
            'We believe the fate of humanity will be decided at the frontier of technological innovation.'
        },
        {
          title: 'Self Sovereignty',
          body:
            'We are committed to building organizational forms that defend self-sovereignty where a user can always exercise choice, either by participating or exiting.'
        },
        {
          title: 'Collaboration',
          body:
            'We are committed to creating collaboration mechanisms in which violence is not only disincentivized, but impossible.'
        },
        {
          title: 'Commitment to Decentralization',
          body:
            'We are committed to decentralizing power in order to dismantle unjustified power which usually springs from centralization.'
        },
        {
          title: 'Sustainability',
          body:
            'We are committed to the creation of long-term value versus short-term profit which in turn, advances sustainability.'
        },
        {
          title: 'Our Commitment',
          body:
            'We are committed to a world in which every person can participate in these new organizational structures.'
        }
      ]}
      {...props}
    />
  )
}
